import { Flex } from '@chakra-ui/layout';
import { format } from 'd3-format';
import { isEmpty, startCase, truncate } from 'lodash';

import type {
  RankedLeaderboard,
  RankedScoreItem,
} from '../utils/getUpdatedLeaderboard';
import { LeaderboardItem } from './LeaderboardItem';

interface LeaderboardProps {
  value: RankedLeaderboard;
}

const formatRankString = (rank: number) => {
  if (rank > 3 && rank < 21) {
    return `${rank}th`;
  }

  switch (rank % 10) {
    case 1:
      return `${rank}st`;
    case 2:
      return `${rank}nd`;
    case 3:
      return `${rank}rd`;
    default:
      return `${rank}th`;
  }
};

const formatUsername = (email: string, playerid: string) => {
  // console.log('email', email);
  if (!email || isEmpty(email)) {
    return truncate(playerid, {
      length: 14,
      omission: '',
    });
  }

  return email.split('@')[0];
};

const formatResultsString = (seniority: string, role: string, msa: string) => {
  return `${`${startCase(seniority)} ${startCase(role)} in ${startCase(msa)}`}`;
};

export const Leaderboard = ({ value }: LeaderboardProps) => {
  return (
    <Flex direction="column" alignItems="center" rowGap={4}>
      {value.map((v: RankedScoreItem) => (
        <LeaderboardItem
          key={v.playerid + v.email + v.salary + v.seniority + v.role + v.msa}
          rank={formatRankString(v.rank)}
          // @ts-expect-error noUncheckedIndexedAccess
          username={formatUsername(v.email, v.playerid)}
          result={formatResultsString(v.seniority, v.role, v.msa)}
          salary={format('$,')(v.salary)}
          isCurrent={v.isNew}
        />
      ))}
    </Flex>
  );
};
